import toast from 'react-hot-toast';
import { KIDDOWARE_ACCOUNT_URL, SEARCH_LICENSE_UPGRADE_HINT } from '../config/kiddowareUrls';

/** User-facing toast when preflight returns license_required. */
export function notifySearchLicenseRequired() {
  toast.error(
    `${SEARCH_LICENSE_UPGRADE_HINT} Upgrade at ${KIDDOWARE_ACCOUNT_URL.replace('https://', '')}.`,
    { duration: 6500 },
  );
}
